import React, { useState } from "react"
import PropTypes from "prop-types"

import FieldHeader from "./field-header"

const LocationFieldRowTitles = ({fields}) => {
  const [fieldActive, setFieldActive] = useState()

  const handleHeaderClicked = (index) => {
    fieldActive === index ? setFieldActive() : setFieldActive(index)
  }

  return (
    <div className="col locked">
      <table className="location-timetable__table rows">
        <thead>
          <tr>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {fields.map((field, index) =>
            <FieldHeader
              key={field.id}
              id={field.id}
              active={fieldActive === index}
              onClick={() => handleHeaderClicked(index)}
            />
          )}
        </tbody>
      </table>
    </div>
  )
}

LocationFieldRowTitles.propTypes = {
  fields: PropTypes.array.isRequired
}

export default LocationFieldRowTitles
